<template>
    <dashboard-layout>
        <!--        <form @submit.prevent="getResults">-->


        <!--            <div class="form-group row">-->
        <!--                <label class="col-sm-2 col-form-label">الاسم</label>-->
        <!--                <div class="col-sm-10">-->
        <!--                    <input type="text" class="form-control " v-model="q.name">-->

        <!--                </div>-->
        <!--            </div>-->

        <!--            <div class="form-group row">-->
        <!--                <label class="col-sm-2 col-form-label">التخصص</label>-->
        <!--                <div class="col-sm-10">-->
        <!--                    <select class="form-control" v-model="q.specialty_id">-->
        <!--                        <option value="" selected>All</option>-->
        <!--                        <option v-for="option in form_options?.specialty_id" :value="option.id">{{-->
        <!--                                option.name-->
        <!--                            }}-->
        <!--                        </option>-->
        <!--                    </select>-->
        <!--                </div>-->
        <!--            </div>-->

        <!--            <div class="form-group row">-->
        <!--                <label class="col-sm-2 col-form-label">المحتوى</label>-->
        <!--                <div class="col-sm-10">-->
        <!--                    <input type="text" class="form-control " v-model="q.content">-->
        <!--                </div>-->
        <!--            </div>-->


        <!--            <div class="form-group">-->
        <!--                <button type="submit" class="btn btn-primary">Search</button>-->
        <!--            </div>-->
        <!--        </form>-->

        <h3>{{ specialty.name }}</h3><br/>
        <div class="list-group">

            <router-link
                v-for="item in items?.data" :key="item.id"
                :to="{'name' : 'book_sections.index' , params: { 'subscribe_id': $route?.params?.subscribe_id, 'chapter_id' : item.id,  }}"
                class="list-group-item list-group-item-action "
            >
                {{ item?.name }}
            </router-link>
        </div>


        <Bootstrap5Pagination
            class="mb-0"
            :data="items"
            :limit="2"
            :show-disabled="false"
            :size="'default'"
            :align="'center'"
            @pagination-change-page="getResults"
        />

    </dashboard-layout>
</template>

<script>

import {useToast} from "vue-toastification";
import {Bootstrap5Pagination} from 'laravel-vue-pagination'
import DashboardLayout from "../../dashboard-layout.vue";

const toast = useToast();

export default {
    components: {
        DashboardLayout,
        Bootstrap5Pagination
    },
    data() {
        return {
            specialty: [],
            items: [],
            q: this.$route.query,
            form_options: {},
        }
    },
    created() {
        this.getResults();
        // this.show( this.$route?.params?.specialty_id);
    },
    methods: {
        getResults(page = this.$route?.query?.page ?? 1) {

            const id = toast.info('Getting content ...', {icon: 'fa-solid fa-download'});

            axios.get('book_chapters', {
                params: {
                    'page': page,
                    'specialty_id' : this.$route?.params?.specialty_id,
                    'subscribe_id': this.$route?.params?.subscribe_id
                    // 'name': this.q.name,
                    // 'specialty_id': this.q.specialty_id,
                    // 'content': this.q.content
                }
            }).then(response => {
                toast.dismiss(id);
                this.items = response.data;
                this.specialty = response.data.specialty.data;

                // this.$router.replace({
                //     name: "book_chapters.index",
                //     query: {
                //         'page': page,
                //         'name': this.q.name,
                //         'specialty_id': this.q.specialty_id,
                //         'content': this.q.content
                //     }
                // });
            }).catch(error => {
                toast.dismiss(id);
                toast.error(`Error: ${error.response ? error.response.data.message : 'An error occurred'}`);
            });

        },
        // show(specialty_id) {
        //
        //     const id = toast.info('Getting content ...',{ icon: 'fa-solid fa-download' });
        //
        //     axios.get(`book_specialties/${specialty_id}`, {}).then(response => {
        //
        //         this.specialty = response.data.data;
        //
        //         toast.dismiss(id);
        //     }, response => {
        //         toast.dismiss(id);
        //     });
        // },
    }
}
</script>
